export default function ChannelStrip({ title, copy, featured }) {
  return (
    <article
      className={`quiet-strip ${featured ? "qs-featured" : ""}`}
      data-testid={`channel-strip-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
    >
      {featured && (
        <span className="qs-live">
          <span className="qs-live-dot" />
          Live
        </span>
      )}
      <h3>{title}</h3>
      <p>{copy}</p>
    </article>
  );
}